module.exports = __webpack_public_path__ + "img/hi.e392414b.webp";